
import * as React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'danger';
  size?: 'sm' | 'md' | 'lg';
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className,
  ...props
}) => {
  const baseStyles = [
    'inline-flex items-center justify-center',
    'font-medium',
    'rounded-xl',
    'transition-all duration-200',
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400/50 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0a0a0f]',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    'gap-2',
    'active:scale-[0.98]',
  ].join(' ');

  const variantStyles = {
    primary: [
      'bg-gradient-to-r from-cyan-500 to-blue-500',
      'hover:from-cyan-400 hover:to-blue-400',
      'text-white',
      'shadow-lg shadow-cyan-500/25',
      'hover:shadow-cyan-400/30',
    ].join(' '),
    secondary: [
      'bg-white/5',
      'border border-white/10',
      'text-white',
      'hover:bg-white/10',
      'hover:border-white/20',
      'backdrop-blur-sm',
    ].join(' '),
    danger: [
      'bg-red-500/10',
      'border border-red-500/30',
      'text-red-400',
      'hover:bg-red-500/20',
      'hover:border-red-500/40',
    ].join(' '),
  };

  const sizeStyles = {
    sm: 'px-3.5 py-1.5 text-sm min-h-[44px]',
    md: 'px-5 py-2.5 text-sm min-h-[44px]',
    lg: 'px-6 py-3 text-base min-h-[48px]',
  };

  return (
    <button
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className ?? ''}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
};
